const api = '/api/v1/u004_r_recoms_controller.php';
import axios from 'axios';
export const recoms_repository =  {
    get(data){
        return  axios.post(api,data);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

